"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editorialCategoryOrPageQuery = void 0;
var _fetching = require("@ori/fetching");
var _editorialArticlePageFragment = require("./editorialArticlePageFragment");
var _editorialCategoryPageFragment = require("./editorialCategoryPageFragment");
const editorialCategoryOrPageQuery = exports.editorialCategoryOrPageQuery = (0, _fetching.gql)`
  query EditorialCategoryOrPage(
    $pageId: ID!
    $landingPageId: ID
    $includeThemeItems: Boolean! = false
    $includeRoot: Boolean! = true
  ) {
    application {
      ...EditorialArticlePage
      ...EditorialCategoryPage
    }
  }
  ${_editorialCategoryPageFragment.editorialCategoryPageFragment}
  ${_editorialArticlePageFragment.editorialArticlePageFragment}
`;
